import { FC } from 'react';
import styled from 'styled-components';
import { BookableListItemType } from '../list.types';
import { BookableListItemConnected } from './BookableListItem.container';

const OuterWrapper = styled.div`
  display: flex;
`;

const InnerWrapper = styled.div`
  flex-grow: 1;
`;

type BookableListProps = {
  items: BookableListItemType[];
  numberOfRooms?: number;
  isFetching?: boolean;
};

export const BookableList: FC<BookableListProps> = ({
  items = [],
  numberOfRooms,
  isFetching = false,
}) => (
  <OuterWrapper>
    <InnerWrapper>
      {items.map((item) => (
        <BookableListItemConnected
          key={item.id}
          numberOfRooms={numberOfRooms}
          {...item}
          isFetching={isFetching}
        />
      ))}
    </InnerWrapper>
  </OuterWrapper>
);
